define('app/views/shipping_view',[
 'app/setup', 'app/models/shipping_address',
 'app/views/shipping_address_form_view', 'app/views/shipping_method_view',
 'app/views/shipping_address_view', 'app/collections/shipping_methods',
 'app/models/shipping_method'
], function(
  takhfifan, shippingAddress, shippingAddressForm, shippingMethodView,
  shippingAddressView, shippingMethods, shippingMethod
) {

  takhfifan.ShippingView = Backbone.View.extend({

    events: {
      'click .tkh-new-shipping-address': 'newAddressForm',
      'click .tkh-shipping-next-btn': 'submitShippingWithStepChange'
    },

    initialize: function() {
      var _this = this;
      _this.autoSubmitShipping = false;
      this._shippingAddressViews = {};
      _this.isGuest = _this.$el.data('isguest');
      _this.guestAddressSubmitted = false;
      _this.goToPaymentAllowed = false;
      this.$submitBtn = $('.tkh-shipping-next-btn');
      this.submitBtnText = this.$submitBtn.text();

      this.initAddressViews();
      this.initShippingMethodView();

      takhfifan.eventHub.on('checkout:shipping', function() {
        _this.render();
        if(!_this.autoSubmitShipping && !_this.isGuest && _this.has_one_active_address) {
          _this.autoSubmitShipping = true;
          _this.submitShipping();
        }

        if(_this.isGuest) {
          _this.$el.find('.tkh-shipping-next-btn').hide();
        }
      }, this);

      takhfifan.eventHub.on('checkout:payment', function() {
        this.$el.hide();
      }, this);

      takhfifan.eventHub.on('checkout:login', function() {
        this.$el.hide();
        _this.guestAddressSubmitted = false;
      }, this);

      takhfifan.eventHub.on('checkout:guestaddress', function() {
        _this.guestAddressSubmitted = false;
      }, this);

      takhfifan.eventHub.on('shipping:deselectAddresses', function(data) {
        this.deselectAddresses();
      }, this);

      takhfifan.eventHub.on('shipping:edit', function(shippingAddress) {
        this.showAddressForm(shippingAddress);
        this.deselectAddresses();
      }, this);

      takhfifan.eventHub.on('shipping:error', function(errors) {
        _this.renderErrors(errors);
      }, this);

      takhfifan.eventHub.on('shipping:invalid', function(errors) {
        _this.showActiveAddressForm();
      }, this);

      takhfifan.eventHub.on('shipping:saved', function(data) {
        this.enableSubmitBtn();
        if(_this.goToPaymentAllowed) {
          _this.$('.alert-error').empty().hide();
          _this.$el.hide();
            takhfifan.eventHub.trigger('checkout:payment');
            _this.goToPaymentAllowed = false;
        }
        this.$('.total-price-number em').text(data.grand_total);
      }, this);

      takhfifan.eventHub.on('shipping:total_updated', function(total) {
        _this.$('.total-price-number em').text(total);
      }, this);

      takhfifan.eventHub.on('shipping:updated', function(address) {
        var addressId = address.get('shipping_address_id');
        var addressView = this._shippingAddressViews[addressId];

        this.deselectAddresses();

        if (_.isUndefined(addressView) || _.isNull(addressView)) {
          var $el = this.$('.tkh-new-shipping-address').first();
          addressView = new takhfifan.ShippingAddressView({
            el: $el,
            model: address,
            addressId: addressId
          });
          $el
          .removeClass('empty tkh-new-shipping-address')
          .addClass('tkh-shipping-address');
          addressView.render();
          addressView.setActive();
        } else {
          addressView.model = address;
          addressView.render();
          addressView.setActive();
        }
      }, this);

      _this.skipAddressCheck = false;

      takhfifan.eventHub.on('shipping:method_updated', function(data) {
        _this.skipAddressCheck = true;
      });

      takhfifan.eventHub.on('guest_customer_address_info:saved', function(data) {
        _this.guestAddressSubmitted = true;
        _this.$el.find('.tkh-shipping-next-btn').show();
      });

      takhfifan.eventHub.on('yadisaCO:addingAddress', function() {
        _this.newAddressForm();
      });

      takhfifan.eventHub.on('formkey', function(formKey) {
        this.$el.removeClass('disable');
      }, this);

    },

    render: function() {
      this.$el.show();
    },

    getRegionCodes: function() {
      if (_.isUndefined(this.shippingForm) || _.isNull(this.shippingForm)) {
        return $(_.template($('#tkh-shipping-address-form').html())(
          { data: {}}
        )).find('li').map(function() {
          return $(this).data('region-id')
        });
      } else {
        return this.shippingForm.model.get('availableRegionCodes');
      }
    },

    initAddressViews: function() {
      var _this = this;
      var action = this.$('#tkh-shipping-add-address').data('action');
      _this.has_one_active_address = false;

      this.$('.tkh-shipping-address').each(function() {
        var $el = $(this);
        var data = $el.data();
        var address = new takhfifan.ShippingAddress({
          saveUrl: action
        });

        address.loadFormData(data);
        address.set('availableRegionCodes', _this.getRegionCodes());

        var shippingAddressView = new takhfifan.ShippingAddressView({
          el: $el,
          model: address
        });

        if (data.isActive == '1') {
          if (shippingAddressView.isAddressValid()) {
            _this.has_one_active_address = true;
            shippingAddressView.setActive();
            this._activeAddressView = shippingAddressView;
          }
        }

        _this._shippingAddressViews[data.addressId] = shippingAddressView;
      });
      if(Object.keys(_this._shippingAddressViews).length > 0 && !_this.has_one_active_address) {
        first = _this._shippingAddressViews[Object.keys(_this._shippingAddressViews)[0]];
        first.setActive();
        first.submitAddress();
      }
    },

    initShippingMethodView: function() {
      var _this = this;
      var $el = this.$('#tkh-shipping-method');
      var shippingMethods = new takhfifan.ShippingMethods();
      var $methods = $el.find('ul li');
      var selected = $el.data('code');

      $methods.each(function(i, method){
        var $m = $(method);
        var code = $m.data('code');
        var $method = new takhfifan.ShippingMethod({
          code: code,
          price: $m.data('price'),
          title: $m.text(),
          isSelected: (code == selected && !_.isUndefined(selected))
        });
        shippingMethods.add($method);
      });

      this.shippingMethodView = new takhfifan.ShippingMethodView({
        el: $el,
        collection: shippingMethods
      });
    },

    deselectAddresses: function() {
      _.each(this._shippingAddressViews, function(view) {
        view.setInactive();
      });
    },

    newAddressForm: function() {
      this.loadAddressForm(false);
    },

    showAddressForm: function(shippingAddress) {
      this.loadAddressForm(shippingAddress);
    },

    showActiveAddressForm: function() {
      var $addressViews = this._shippingAddressViews;
      var _this = this;

      if (_.size($addressViews) > 0) {
        _.each($addressViews, function(address){
          if (address.isActive()) {
            _this.loadAddressForm(address.model);
          }
        });
        if (!_.isUndefined(this.shippingForm)) {
          this.shippingForm.validate();
        } else {
          this.newAddressForm();
        }
      } else {
        this.newAddressForm();
      }
    },

    loadAddressForm: function(shippingAddress) {
      if (shippingAddress == false) {
        shippingAddress = new takhfifan.ShippingAddress({
          saveUrl: this.$('#tkh-shipping-add-address').data('action')
        });
        shippingAddress.set('availableRegionCodes', this.getRegionCodes());
      }

      if (_.isUndefined(this.shippingForm) || _.isNull(this.shippingForm)) {
        this.shippingForm = new takhfifan.ShippingAddressFormView({
          el: this.$('#tkh-shipping-add-address'),
          model: shippingAddress
        });
      } else {
        this.shippingForm.model = shippingAddress;
        this.shippingForm.render();
      }
    },

    loadShippingAddress: function() {
      if (_.isUndefined(this.shippingForm) || _.isNull(this.shippingForm)) {
        var address = new takhfifan.ShippingAddress({
          saveUrl: this.$('#tkh-shipping-add-address').data('action')
        });
        address.set('availableRegionCodes', this.getRegionCodes());
        return address;
      }
      return this.shippingForm.model;
    },

    submitShipping: function(e) {
      var _this = this;
      if(!_this.isGuest || _this.guestAddressSubmitted) {
        var $selector = this.$('.tkh-shipping-address.active');

        if (!_.isUndefined(this.shippingForm)
            && this.shippingForm.$el.is(':visible')
           ) {
             this.goToPaymentAllowed = false;
             this.shippingForm.updateModel();
             this.shippingForm.validate();
             if(this.shippingForm.model.isValid()) {
               this.shippingForm.save(e);
               return false;
             }
             else {
               takhfifan.eventHub.trigger('shipping:invalid');
             }
           }

        if ($selector.length == 1 || _this.guestAddressSubmitted ) {
          this.shippingMethodView.save();
        } else {
          this.goToPaymentAllowed = false;
          var error = i18n.t('choose_shipping_address');
          this.showActiveAddressForm();
          this.renderErrors([error]);
        }
      }
      else {
        takhfifan.eventHub.trigger('guest_customer_address_info:submit',{});
      }
    },

    submitShippingWithStepChange: function(e) {
      this.goToPaymentAllowed = true;
      this.disableSubmitBtn();
      this.submitShipping(e);
    },

    renderErrors: function(errors) {
      this.enableSubmitBtn();
      this.$('.success').empty().hide();
      var $errors = this.$('.alert-error');

      $errors.empty().css({'clear' : 'both', 'margin-top' : '50px'});
      if(_.isArray(errors)){
        _.each(errors, function(e) {
          var $li = $('<li></li>');
          $li.html(e);
          $errors.append($li);
        });
        this.showActiveAddressForm();
      }else{
        $errors.append(errors);
      }
      $errors.show();
    },

    disableSubmitBtn: function () {
      this.$submitBtn.prop('disabled',true).empty().append('<div class="btn-text"><span class="spinner"></span></div>');
    },

    enableSubmitBtn: function () {
      this.$submitBtn.prop('disabled',false).empty().append(this.submitBtnText);
    }

  });

  $('.tkh-shipping').each(function(){
    var $this = $(this);
    new takhfifan.ShippingView({
      el: $this
    });
  });

});

